import axios from "axios";
import store from "../store";

const service = axios.create({
  // 设置了代理（解决跨域）
  // 旧版教育业务（/api 那一半）已清理，后台只剩 OPC 控制台，网关前缀固定为 /api/opc。
  baseURL: "/api/opc",
  timeout: 5000,
});

// 后端有两处「身份不可用」的返回，两边都要认：
//   /admin/**  由 OpcAdminInterceptor 拦下 → HTTP 403 + code 403「需要 OPC 管理员权限」
//   /api/**    由 ApiAuthInterceptor  拦下 → HTTP 401 + code 401「未登录或登录已过期」
// 管理端只调 /admin/**，所以 token 过期在浏览器里表现为 403，不是 401。
function handleAuthFailure(config) {
  // 登录接口自身失败时，后端返回的是 HTTP 200 + body code 401（Result 是普通 POJO，
  // 不改 HTTP 状态），走不到这里。这里再挡一次，是防止将来前面套了网关把 code 映射成
  // HTTP 状态时，把用户刚填的登录表单冲掉。
  if (/\/admin\/auth\/login$/.test((config && config.url) || "")) return;

  // delToken 会一并清掉 opc_admin_token 与 opc_admin_user（见 store/index.js），
  // 所以这里不用再单独 remove。
  store.commit("delToken");

  // OpcConsole 的 loggedIn 是组件内部状态，只清 localStorage 不会让它切回登录视图，
  // 所以整页刷新让 created() 重新判断。用 sessionStorage 打一次性标记，
  // 防止「刷新后仍然 403 → 无限刷新」。
  if (sessionStorage.getItem("opc_auth_reloaded")) {
    window.location.hash = "#/opc-admin";
  } else {
    sessionStorage.setItem("opc_auth_reloaded", "1");
    window.location.reload();
  }
}

// 添加请求拦截器，若token存在则在请求头中加token，不存在也继续请求
service.interceptors.request.use(
  (config) => {
    // 每次发送请求之前都检测vuex是否存有token，放在请求头发送给服务器
    // Authorization是根据后端自定义字段
    config.headers.Authorization = store.getters.getToken;
    return config;
  },
  (error) => {
    console.log("在request拦截器显示错误", error.response);
    return Promise.reject(error);
  }
);

// response拦截器
service.interceptors.response.use(
  (response) => {
    // 有请求成功即说明登录态是好的，重置上面那个一次性刷新标记
    sessionStorage.removeItem("opc_auth_reloaded");
    return response.data.code == 200
      ? response
      : Promise.reject(response.data);
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
        case 403:
          handleAuthFailure(error.config);
          break;
        case 500:
          // 服务端异常：清 token。旧 /login 页面已随遗留半区删除，不再跳转。
          store.commit("delToken");
          break;
      }
    }
    return Promise.reject(error.response ? error.response.data : error);
  }
);

export default service;
